"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Function["default"];
  }
});
var _Function = _interopRequireDefault(require("./Function"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }